import { goldGradientButtonHero, ctaRadius } from '@/lib/brandGradient'
import { useNavigate } from 'react-router-dom'

export const HomeCtas = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center gap-6 sm:gap-5">
      <div className="flex w-full max-w-[300px] flex-col items-stretch gap-6 sm:max-w-lg sm:flex-row sm:gap-5">
        <button
          className={`inline-flex h-[46px] min-h-[46px] min-w-0 flex-1 items-center justify-center px-3 text-center text-sm leading-none font-semibold sm:px-6 sm:text-base ${goldGradientButtonHero}`}
          type="button"
          onClick={() => navigate('/submit-idea')}
        >
          Submit Your IDEA
        </button>

        <button
          className={`inline-flex h-[46px] min-h-[46px] min-w-0 flex-1 items-center justify-center ${ctaRadius} border-[1.5px] border-[#E0A263]/65 bg-[#F6CB86]/[0.06] px-3 text-center text-sm leading-none font-semibold text-white transition hover:border-[#E0A263]/90 hover:bg-[#F6CB86]/14 active:brightness-[0.98] sm:px-6 sm:text-base`}
          type="button"
          onClick={() => navigate('/validate-ideas')}
        >
          Start Validating IDEAS
        </button>
      </div>
      <p className="max-w-lg px-2 text-center text-xs leading-relaxed text-white/50 sm:text-[13px]">
        Free to join. No credit card required.
      </p>
    </div>
  )
}
